@use 'list-group-vars';
@use 'list-group-common';

:host {
  @include list-group-vars.wb-list-group-vars;
  @include list-group-common.wb-list-group;
}

:host([hide-border]) {
  @include list-group-common.wb-list-group-hide-border;
}
